export default {"src":"/_next/static/media/plan.5edbd893.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};